export class ListRequest {
  index: number = 1;
  size: number = 15;
  option?: any;
}



// WEBPACK FOOTER //
// ./src/app/view-model/internal/listrequest.ts